// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--VS9Bi","main":"title-module--main--2TdlX","details":"title-module--details--_ThBY"};